@if (recommendationsFound) {
  <div
    id="frequently-bought-together"
    class="frequently-bought-together hmf-my-m hmf-mt-m-xl"
    [ngClass]="{ 'fbt-improvements background-base-subtle hmf-mb-l hmf-mb-m-xl': isFBTImprovementsEnabled() }">
    <div class="pdp-content-width hmf-mx-auto hmf-my-0 hmf-display-flex hmf-flex-column hmf-justify-content-between">
      <div class="fbt-wrapper hmf-py-m hmf-pt-m-xl hmf-px-lg-m"
			[ngClass]="{
				'fbt-container': isPL && !isFBTImprovementsEnabled(),
				'hmf-py-m-xl': isFBTImprovementsEnabled()
			}">
        <div class="header-container">
          <!-- HEADER SECTION -->
          <!-- title -->
          <div class="hmf-display-flex hmf-flex-wrap hmf-mx-0">
            <div class="add-on-title">
              {{certonaTitle}}
            </div>
          </div>
          <!-- divider -->
          <div class="hmf-display-flex hmf-flex-wrap hmf-mx-0 hmf-justify-content-center">
            <div class="orange-line"></div>
          </div>
        </div>
        <div class="content-container">
          <div class="hmf-grid hmf-justify-content-center hmf-display-flex hmf-mx-auto hmf-my-0">
            <!-- Beginning of improvements -->
            @if (isFBTImprovementsEnabled()) {
              <div class="hmf-overflow-x-auto hmf-overflow-y-hidden hmf-px-xs-0 hmf-span-12 hmf-mt-m hmf-display-flex hmf-justify-content-m-center">
                <!-- card container -->
                <div class="cart-product-recommendation-card-container slide-container hmf-display-flex hmf-justify-content-sm-center hmf-mx-auto hmf-my-0 hmf-pt-s hmf-pb-xxxs">
                  <!-- card -->
                  @if (rootProduct) {
                    <div
                      class="individual-card-container individual-card-container-slide background-base dcsg-card hmf-soft-radius hmf-p-xxs hmf-p-m-xs hmf-display-flex hmf-flex-column hmf-justify-content-between hmf-align-items-stretch"
                      [id]="rootProduct.id + randomUUIDForProductCard">
                       @if (isFBTFavoriteButtonEnabled()) {
                        <shared-favorites-components-auth-icon
                          class="favorites-icon"
                          [ecode]="rootProduct.id"
                          [isAuthenticated]="isAuthenticated()"
                          [favoritedECodes]="favoritedECodes()"
                          [location]="FavoritesLocationEnum.FBT">
                        </shared-favorites-components-auth-icon>
                      }
                      <div class="cart-product-recommendations root-product"
                        [ngClass]="{'white-out': !rootProduct.selected}">
                        <div class="cart-product-image-title-wrapper hmf-p-0 hmf-position-relative">
                          <!-- image -->
                          <div class="product-image-wrapper hover-pointer hmf-display-flex hmf-flex-column"
                            (click)="openQuickviewPanel(rootProduct, true);">
                            @if (!rootProductImageUnavailable) {
                              <img class="cross-sell-img root-product-image product-image set-height hmf-align-self-center hmf-mt-0 hmf-my-m-0 hmf-mx-m-auto hmf-p-0"
                                [ngClass]="[isPL ? 'pl-product-image':'product-image']"
                                [src]="rootProduct?.imageUrl"
                                alt=""
                                loading="lazy"/>
                            }
                            @else {
                            <img class="cross-sell-img root-product-image product-image set-height hmf-align-self-center hmf-mt-0 hmf-my-m-0 hmf-mx-m-auto hmf-p-0"
                              [ngClass]="[isPL ? 'pl-product-image':'product-image']"
                              src="https://images.dickssportinggoods.com/assets/icons/dsg/ImageUnavailablePDPSwatch.svg?qlt=70&wid=350&fmt=webp&op_sharpen=1"
                              alt=""
                              loading="lazy"/>
                          }
                        </div>
                        <div class="root-product-floating-tag root-product-tag">
                          <hmf-badge badgeName="ViewingItem"/>
                        </div>
                      </div>
                    </div>
                    <div class="individual-card-container-description">
                      <div class="individual-card-container-title hover-pointer hmf-mt-xxs hmf-mt-m-xs hmf-mb-xxxs"
                        (click)="openQuickviewPanel(rootProduct, true);">
                        {{ rootProduct.title }}
                      </div>
                      <div class="hmf-body-bold-m hmf-body-bold-m-l hmf-mb-xxxs hmf-mb-m-xxs">
                        @if (rootProduct?.shownPrice?.isSeePriceInCart) {
                          <div>See Price In Cart</div>
                        }
                        @if (!rootProduct?.shownPrice?.isSeePriceInCart) {
                          <div>
                            <span>{{ rootProduct?.shownPrice.lowestPrice | currency }}
                              @if (rootProduct?.shownPrice.isRangePrice) {
                                <span>-
                                {{ rootProduct?.shownPrice.highestPrice | currency }}</span>
                              }
                            </span>
                          </div>
                        }
                      </div>
                      <!-- Root product's attributes -->
                      @if (rootProduct.skuItem &&
                        rootProduct.skuItem.definingAttributes &&
                        !showColorAttributeLabel) {
                        <div
                          class="product-attributes hover-pointer hmf-text-decoration-underline hmf-legal-s"
                          (click)="openQuickviewPanel(rootProduct, true);">
                          @for (defAttribute of rootProduct.skuItem.definingAttributes; track trackByFn(i, defAttribute); let i = $index) {
                            <div
                              class="product-attributes hmf-display-inline">
                              <span>{{ i === 0 ? '' : ' | ' }}{{defAttribute.value}}</span>
                            </div>
                          }
                        </div>
                      }
                      @if (showColorAttributeLabel) {
                        <div
                          class="product-attributes hover-pointer hmf-text-decoration-underline hmf-legal-s"
                          (click)="openQuickviewPanel(rootProduct, true);">
                          <div class="product-attributes hmf-display-inline">
                            {{ unformattedSelectedColorAttribute }}
                          </div>
                        </div>
                      }
                      @if (!rootProduct?.skuItem?.definingAttributes) {
                        <div class="hmf-p-xxs"></div>
                      }
                    </div>
                    <div class="hmf-display-xs-flex hmf-display-md-none">
                      <button
                        hmf-button
                        id="fbt-add-to-cart-root-product-mobile"
                        class="fbt-add-to-cart-mobile hmf-mx-0 hmf-px-xs hmf-mt-xs hmf-mt-m-s hmf-text-align-center"
                        [variant]="'secondary'"
                        [text]="'Add'"
                        [size]="'medium'"
                        [loading]="false"
                        [disabled]="false"
                        [label]="'Add'"
                        [icon]="'order-cart-standard'"
                        (click)="openQuickviewPanel(rootProduct, true);">
                      </button>
                    </div>
                    <div class="hmf-display-none hmf-display-md-flex">
                      <button
                        hmf-button
                        id="fbt-add-to-cart-root-product"
                        class="fbt-add-to-cart hmf-mx-0 hmf-px-xs hmf-mt-xs hmf-mt-m-s"
                        [variant]="'secondary'"
                        [text]="atcButtonTexts.atc"
                        [size]="'medium'"
                        [loading]="false"
                        [disabled]="false"
                        [label]="atcButtonTexts.atc"
                        [icon]="'order-cart-standard'"
                        (click)="openQuickviewPanel(rootProduct, true);">
                      </button>
                    </div>
                  </div>
                }
                <!-- card -->
                @for (product of slicedCardDataList; track trackByProduct(productIndex, product); let productIndex = $index) {
                  <div
                    class="individual-card-container individual-card-container-slide background-base dcsg-card hmf-soft-radius hmf-p-xxs hmf-p-m-xs hmf-display-flex hmf-flex-column hmf-justify-content-between hmf-align-items-stretch"
                    [id]="product.id + randomUUIDForProductCard">
                    @if (isFBTFavoriteButtonEnabled()) {
                      <shared-favorites-components-auth-icon
                          class="favorites-icon"
                          [ecode]="product.id"
                          [isAuthenticated]="isAuthenticated()"
                          [favoritedECodes]="favoritedECodes()"
                          [location]="FavoritesLocationEnum.FBT">
                      </shared-favorites-components-auth-icon>
                    }
                    <div class="hmf-display-flex hmf-flex-column"
                      target="_blank">
                      <div class="cart-product-recommendations" [id]="product.id">
                        <div class="cart-product-image-title-wrapper hmf-p-0" [ngClass]="{'white-out': !product.selected}">
                          <!-- image -->
                          <div class="product-image-wrapper hover-pointer hmf-display-flex hmf-flex-column"
                            (click)="openQuickviewPanel(product);">
                            <img class="cross-sell-img product-image hmf-align-self-center hmf-mt-0 hmf-my-m-0 hmf-mx-m-auto hmf-p-0"
                              [src]="product?.imageUrl" alt="" loading="lazy" (error)="productCardImageUnavailable(productIndex)" />
                          </div>
                        </div>
                      </div>
                      <div class="individual-card-container-description">
                        <div class="individual-card-container-title hover-pointer hmf-mt-xxs hmf-mt-m-xs hmf-mb-xxxs"
                          (click)="openQuickviewPanel(product);">
                          {{ product.title }}
                        </div>
                        <div class="hmf-body-bold-m hmf-body-bold-m-l hmf-mb-xxxs hmf-mb-m-xxs">
                          @if (product?.shownPrice?.isSeePriceInCart) {
                            <div>See Price In Cart</div>
                          }
                          @if (product?.skuItem?.prices.offerPrice) {
                            <span>{{ product?.skuItem?.prices.offerPrice | currency }}</span>
                          }
                          @if (!product?.skuItem?.prices.offerPrice) {
                            <span>{{ product?.shownPrice.lowestPrice | currency }}</span>
                          }
                        </div>
                        @if (!product.errorMessage &&
                          product.skuItem &&
                          product.skuItem.definingAttributes) {
                          <div
                            class="product-attributes hover-pointer hmf-text-decoration-underline hmf-legal-s"
                            (click)="openQuickviewPanel(product);">
                            @for (defAttribute of product.skuItem.definingAttributes; track trackByFn(i, defAttribute); let i = $index) {
                              <div
                                class="product-attributes hmf-display-inline">
                                <span>{{ i === 0 ? '' : ' | ' }}{{defAttribute.value}}</span>
                              </div>
                            }
                          </div>
                        }
                        @if (!product.skuItem || !product.skuItem.definingAttributes) {
                          <div class="hmf-p-xxs"></div>
                        }
                      </div>
                    </div>
                    <div class="hmf-display-xs-flex hmf-display-md-none">
                      <button
                        hmf-button
                        id="fbt-add-to-cart-{{productIndex}}-mobile"
                        class="fbt-add-to-cart-mobile hmf-mx-0 hmf-px-xs hmf-mt-xs hmf-mt-m-s hmf-text-align-center"
                        [variant]="'secondary'"
                        [text]="'Add'"
                        [size]="'medium'"
                        [loading]="false"
                        [disabled]="false"
                        [label]="'Add'"
                        [icon]="'order-cart-standard'"
                        (click)="openQuickviewPanel(product);">
                      </button>
                    </div>
                    <div class="hmf-display-none hmf-display-md-flex">
                      <button
                        hmf-button
                        id="fbt-add-to-cart-{{productIndex}}"
                        class="fbt-add-to-cart hmf-mx-0 hmf-px-xs hmf-mt-xs hmf-mt-m-s"
                        [variant]="'secondary'"
                        [text]="atcButtonTexts.atc"
                        [size]="'medium'"
                        [loading]="false"
                        [disabled]="false"
                        [label]="atcButtonTexts.atc"
                        [icon]="'order-cart-standard'"
                        (click)="openQuickviewPanel(product);">
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="hmf-col hmf-span-12 hmf-span-md-9">
              <!-- card container -->
              <div class="cart-product-recommendation-card-container slide-container hmf-display-flex hmf-mt-xxs">
                <!-- card -->
                @if (rootProduct) {
                  <div
                    class="individual-card-container individual-card-container-slide hmf-display-flex hmf-flex-column hmf-align-items-stretch"
                    [id]="rootProduct.id + randomUUIDForProductCard">
                    <div class="cart-product-recommendations root-product"
                      [ngClass]="{'white-out': !rootProduct.selected}">
                      <div class="cart-product-image-title-wrapper dcsg-card border"
                        [ngClass]="[isPL ? 'root-product-pl-image-wrapper':'root-product-image-wrapper']">
                        <!-- image -->
                        <div class="hmf-display-flex hmf-flex-column">
                          <img class="cross-sell-img root-product-image hmf-align-self-center hmf-mt-m hmf-mt-m-xl"
                            [ngClass]="[isPL ? 'pl-product-image':'product-image']"
                            [src]="rootProduct?.imageUrl"
                            alt=""
                            loading="lazy"/>
                        </div>
                        <p class="label-font hmf-px-xs"
                          [ngClass]="[isPL ? 'root-product-pltag':'root-product-tag']">
                          This Item
                        </p>
                      </div>
                    </div>
                    <!-- ADD ICON -->
                    <homefield-icon
                      class="product-add-icon"
                      width="32px"
                      height="32px"
                    name="sign-add"></homefield-icon>
                  </div>
                }
                <!-- card -->
                @for (product of slicedCardDataList; track trackByAddOnCard(productIndex, product); let productIndex = $index) {
                  <div
                    class="individual-card-container individual-card-container-slide hmf-display-flex hmf-flex-column hmf-align-items-stretch hmf-ml-m-l"
                    [id]="product.id + randomUUIDForProductCard">
                    <div class="cart-product-recommendations" [id]="product.id">
                      <div class="cart-product-image-title-wrapper dcsg-card" [ngClass]="{'white-out': !product.selected}">
                        <!-- image -->
                        <a class="url addon-product-link hmf-display-flex hmf-flex-column" [href]="product?.pdpSeoUrl"
                          target="_blank">
                          <img class="cross-sell-img product-image hmf-align-self-center"
                            [src]="product?.imageUrl" alt="" loading="lazy"/>
                        </a>
                      </div>
                    </div>
                    <!-- ADD ICON -->
                    @if (productIndex !== slicedCardDataList.length - 1) {
                      <homefield-icon
                        class="product-add-icon"
                        width="32px"
                        height="32px"
                      name="sign-add"></homefield-icon>
                    }
                  </div>
                }
              </div>
              <!-- Check Boxes -->
              <div class="checkbox-section" [ngClass]="{'pl-checkbox-section' : isPL}">
                @if (rootProduct) {
                  <div class="checkbox-container hmf-display-flex">
                    <input type="checkbox" [id]="'checkbox' + rootProduct.id" [checked]="rootProduct.selected" (click)="toggleProductSelection(rootProduct, $event, true)" />
                    <span class="checkmark" (click)="toggleProductSelection(rootProduct, null, true)"></span>
                    <div class="checkbox-text">
                      <label [for]="'checkbox' + rootProduct.id">This Item: <span
                      class="root-product-title">{{rootProduct.title}}</span></label>
                      <div class="checkbox-text-sub hmf-display-flex">
                        @if (rootProduct?.shownPrice.isSeePriceInCart) {
                          <div>See Price In Cart</div>
                        }
                        @if (!rootProduct?.shownPrice.isSeePriceInCart) {
                          <div>
                            <span>{{ rootProduct?.shownPrice.lowestPrice | currency }}
                              @if (rootProduct?.shownPrice.isRangePrice) {
                                <span>-
                                {{ rootProduct?.shownPrice.highestPrice | currency }}</span>
                              }
                            </span>
                          </div>
                        }
                        @if (!rootProduct.errorMessage && rootProduct.skuItem && rootProduct.skuItem.definingAttributes) {
                          <div>
                            @for (defAttribute of rootProduct.skuItem.definingAttributes; track trackByFn($index, defAttribute)) {
                              <span
                                class="root-product-attributes">
                                <span class="attribute-value">&nbsp;| {{defAttribute.value}}</span>
                              </span>
                            }
                          </div>
                        }
                        @if (!rootProduct.errorMessage && rootProduct.skuItem && rootProduct.skuItem.defAttributes) {
                          <div>
                            @for (defAttribute of rootProduct.skuItem.defAttributes; track trackByFn($index, defAttribute)) {
                              <span
                                class="root-product-attributes">
                                <span class="attribute-value">&nbsp;| {{defAttribute.value}}</span>
                              </span>
                            }
                          </div>
                        }
                        @if (rootProduct.errorMessage) {
                          <div>
                            <span>&nbsp;|
                              <span class="error-message">{{rootProduct.errorMessage}}</span>
                            </span>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @for (product of slicedCardDataList; track trackByCardData($index, product)) {
                  <div class="hmf-display-flex hmf-justify-content-between">
                    <div class="checkbox-container hmf-display-flex">
                      <input type="checkbox" [id]="'checkbox' + product.id" [checked]="product.selected" (click)="toggleProductSelection(product, $event)"/>
                      <span class="checkmark" (click)="toggleProductSelection(product)"></span>
                      <div class="checkbox-text">
                        <label [for]="'checkbox' + product.id">{{product.title}}</label>
                        <div class="checkbox-text-sub nowrap hmf-display-flex">
                          @if (product?.shownPrice.isSeePriceInCart) {
                            <div>See Price In Cart</div>
                          }
                          @if (!product?.shownPrice.isSeePriceInCart) {
                            <div>
                              @if (product?.skuItem?.prices.offerPrice) {
                                <span>{{ product?.skuItem?.prices.offerPrice | currency }}</span>
                              }
                              @if (!product?.skuItem?.prices.offerPrice) {
                                <span>{{ product?.shownPrice.lowestPrice | currency }}</span>
                              }
                            </div>
                          }
                          @if (!product.errorMessage && product.skuItem) {
                            <div>
                              @for (defAttribute of product.skuItem.definingAttributes; track trackByFn($index, defAttribute)) {
                                <span
                                  class="root-product-attributes">
                                  <span class="attribute-value">&nbsp;| {{defAttribute.value}}</span>
                                </span>
                              }
                            </div>
                          }
                          @if (product.errorMessage) {
                            <div>
                              <span>&nbsp;|
                                <span class="error-message">{{product.errorMessage}}</span>
                              </span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="hmf-display-md-flex hmf-align-items-center hmf-display-none nowrap hmf-align-self-start">
                      <a class="product-detail-link" [href]="product?.pdpSeoUrl" target="_blank">Product Details</a>
                      <homefield-icon width="32px" height="32px" name="chevron-right"></homefield-icon>
                    </div>
                    <div class="nowrap hmf-display-md-none hmf-mt-xxs">
                      <a class="product-detail-link" [href]="product?.pdpSeoUrl" target="_blank">Details</a>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          <!-- End Of Improvements -->
          @if (!isFBTImprovementsEnabled()) {
            <div class="hmf-col hmf-span-12 hmf-span-md-3">
              <div class="price-and-atc">
                <div class="price-container">
                  <p class="price-text hmf-mb-0">Total Price:</p>
                  <p class="hmf-mt-xxxs hmf-mb-0" [ngClass]="[isPL ? 'plprice':'price']">{{totalPrice | currency}}</p>
                </div>
                <!-- ATC Button -->
                <div class="frequently-bought-together-atc-wrapper hmf-mt-xxs">
                  @if (!addToCartSuccess) {
                    <button
                      hmf-button
                      [variant]="buttonConfig.variant"
                      type="submit"
                      (click)="addProductsToCart()"
                      [disabled]="buttonConfig.disabled"
                      class="frequently-bought-together-atc-button"
                      [text]="addToCartClicked ? 'Adding...' : buttonConfig.text"
                      >
                    </button>
                  }
                  @if (addToCartSuccess) {
                    <button
                      hmf-button
                      variant="secondary"
                      type="submit"
                      [disabled]="true"
                      class="added frequently-bought-together-atc-button"
                      icon="sign-check-circle-filled"
                      text="ADDED"
                      >
                    </button>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}
